import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";

import Table from "components/Table";
import Filter from "@Components/Filter";
const today = new Date();

const from_date =
  today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
let model = [
  { id: "date", label: "Transaction Date", type: "string" },
  { id: "time", label: "Transaction Time", type: "string" },
  { id: "mobile_numbers", label: "Phone Number", type: "string" },
  { id: "user_name", label: "Username", type: "string" },
  { id: "trxn_type", label: "Transaction Type", type: "string" },
  { id: "sms_status", label: "Status", type: "string" },
  { id: "portal", label: "Channel", type: "string" },
  { id: "token", label: "Token", type: "string" },

];

const pageNumberDropdown = true;


const status = [
  {
    id: "success",
    name: "SUCCESS",
  },
  {
    id: "failed",
    name: "FAILED",
  },
];

  
  




// const today = new Date();
// const date =
//   today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();



const SmsReportList = () => {
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const [filterValues, setFilterValues] = useState(filters);
  const [filtersApplied, setFiltersApplied] = useState(false);

  const details = useLocation();

  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const filterInitialValues = {
    from_date: details?.searchParams?.from_date?.dateForAPI || null,
    to_date: details?.searchParams?.to_date?.dateForAPI || null,
    status: details?.searchParams?.status || null,
  };
  let filters = {};
  if ("searchParams" in details) {
    if (details.searchParams.from_date.dateForAPI) {
      filters["from_date"] = details.searchParams.from_date.dateForAPI;
    }
    if (details.searchParams.to_date.dateForAPI) {
      filters["to_date"] = details.searchParams.to_date.dateForAPI;
    }
    if (details.searchParams.status) {
      filters["status"] = details.searchParams.status;
    }
  }
  const getToDate = (e) => {
    setSelectedToDate(e);
  };
  
  const filterFields = [
    {
      type: "datepicker",
      label: "From Date",
      name: "from_date",
      required: true,
      maxDate:selectedtoDate,
      getValue: getFormDate,
    },
    {
      type: "datepicker",
      label: "To Date",
      name: "to_date",
      required: true,
      minDate: selectedFormDate,
      getValue: getToDate,
    },
    {
      type: "reactselect",
      label: "Status",
      name: "status",
      outerOptions: status,
    },
    {
      type: "reactselect",
      label: "Type",
      name: "type",
      outerOptions: [
        { id: "SOS", name: "SOS" },
        { id: "LOGIN", name: "Login" },
      ],
    },
  ];
  const validationSchema = Yup.object({
    from_date: Yup.date().required("Date is required").nullable().typeError("Invalid Attended Date"),
    to_date: Yup.date().required("Date is required").nullable().typeError("Invalid Attended Date"),
   });
  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        validationSchema={validationSchema}
        onClear={() => {
        // reset parent states
        setSelectedFormDate(null);
        setSelectedToDate(null);
        setFilterValues({});
        setFiltersApplied(false);
      }}
      />
  {filtersApplied ? (

      <Table
        proxyURL="sms-trxn/"
        model={model}
        exportUrl="url"
        excelExport={{ fileName: "SmsTrxnReport" }}
        filterValues={filterValues}
        noFilter
        pageNumberDropdown={pageNumberDropdown}

      />
      ) : (
        <Table
        proxyURL={null}
        model={model}
        exportUrl="url"
        excelExport={{ fileName: "SmsTrxnReport" }}
        filterValues={filterValues}
        noFilter
        pageNumberDropdown={pageNumberDropdown}

      />
)}   
    </>
    
  );
};
export default  SmsReportList;


